import { Fragment, FunctionComponent } from "react";
import { IconButton } from "@App/Components/common/IconButton/IconButton";
import { TireSparkleIcon, TireUserIcon, WareHouseIcon } from "@App/Components/common/Icons";
import { Services } from "@App/types/enums";
import { Organization, Service } from "@App/types";
import {
  OrganizationIsArval,
  OrganizationIsAthlon,
  OrganizationIsMeinAuto,
  OrganizationIsMobilityConcept,
  OrganizationIsNio,
} from "@App/utils/conditionals/organization";
import { OrganizationShouldDisplayAsNonBookableForTires } from "@App/utils/conditionals/combinations";

type SecondaryTireServiceStepProps = {
  services: Service[];
  selectService: any;
  organization: Organization;
  secondary: boolean;
};

export const SecondaryTireServiceStep: FunctionComponent<SecondaryTireServiceStepProps> = (
  props: SecondaryTireServiceStepProps,
) => {
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div
          className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}
        >
          <IconButton
            order={OrganizationIsMeinAuto(props.organization) ? 2 : 0}
            title={
              OrganizationIsMeinAuto(props.organization)
                ? "Meine Reifen sind bereits eingelagert"
                : "Ja"
            }
            subtitle={OrganizationIsArval(props.organization) && "Eingelagert / Ohrem"}
            onClick={() =>
              props.selectService(
                false,
                props.services.find((service) => service.id === Services.WHEELCHANGETIRESSTORED),
                true,
                OrganizationIsMeinAuto(props.organization)
                  ? "Meine Reifen sind bereits eingelagert"
                  : "Ja",
                props.secondary,
              )
            }
            icon={<WareHouseIcon primary className={"w-10 h-10"} />}
          />
          <IconButton
            order={OrganizationIsMeinAuto(props.organization) ? 3 : 0}
            title={
              OrganizationIsMeinAuto(props.organization) ? "Ich bringe meine Reifen mit" : "Nein"
            }
            subtitle={OrganizationIsMeinAuto(props.organization) ? "" : "Ich bringe sie mit"}
            onClick={() =>
              props.selectService(
                false,
                props.services.find((service) => service.id === Services.WHEELCHANGE),
                true,
                OrganizationIsMeinAuto(props.organization)
                  ? "Ich bringe meine Reifen mit"
                  : "Nein Ich bringe sie mit",
                props.secondary,
              )
            }
            icon={<TireUserIcon primary className={"w-10 h-10"} />}
          />
          {!OrganizationIsNio(props.organization) &&
            !OrganizationIsMobilityConcept(props.organization) &&
            !OrganizationIsMeinAuto(props.organization) &&
            !OrganizationIsAthlon(props.organization) && (
              <IconButton
                title={"Nein"}
                subtitle={"Ich brauche neue Reifen"}
                onClick={() =>
                  props.selectService(
                    OrganizationShouldDisplayAsNonBookableForTires(props.organization),
                    props.services.find((service) => service.id === Services.WHEELCHANGE),
                    true,
                    "Nein Ich brauche neue Reifen",
                    props.secondary,
                  )
                }
                icon={<TireSparkleIcon primary className={"w-10 h-10"} />}
              />
            )}
          {OrganizationIsMeinAuto(props.organization) && (
            <IconButton
              order={OrganizationIsMeinAuto(props.organization) ? 1 : 0}
              title={"Neue wintertaugliche Bereifung"}
              subtitle={""}
              onClick={() =>
                props.selectService(
                  false,
                  props.services.find((service) => service.id === Services.WHEELREPLACEMENT),
                  true,
                  "Neue wintertaugliche Bereifung",
                  props.secondary,
                )
              }
              icon={<TireSparkleIcon primary className={"w-10 h-10"} />}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};
